import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export const Confirm = props => {
    const {
        title,
        message,
        isOpen,
        toggle,
        onConfirm,
        addTextBox,
        textBoxTitle,
        ...rest
    } = props;
    const [textInput, setTextInput] = useState('');
    return (
        <Modal isOpen={isOpen} toggle={toggle} {...rest}>
            <ModalHeader toggle={toggle}>{title}</ModalHeader>
            <ModalBody>{message}</ModalBody>
            {addTextBox && (
                <>
                    <h5 className="m-0 text-600 mb-2">{textBoxTitle}</h5>
                    <textarea
                        className="form-control"
                        rows="10"
                        value={textInput}
                        onChange={e => setTextInput(e.target.value)}
                    ></textarea>
                </>
            )}
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    Cancel
                </Button>
                <Button
                    color="primary"
                    onClick={() => {
                        toggle();
                        if (addTextBox) onConfirm(textInput);
                        else onConfirm();
                    }}
                >
                    Confirm
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default Confirm;
